<div class="login-wrapper d-flex justify-content-around">
  <div class="background-container" [ngStyle]="('design' | env).rightLogoBgStyle" ></div>
  <div class="left-side">
    <div class="graphic-content">
      <div class="background-logo"></div>
      @if (('design' | env).logoWhiteBg) {
        <div class="background-logo background-logo-2" [ngStyle]="('design' | env).leftLogoBgStyle">
          <!--<div class="background-inner"></div>-->
        </div>
      }
      <div class="actual-logo d-flex flex-column">
        <img class="logo-img" [src]="('design' | env).logoWhiteBg ? 'assets/img/logo.svg' : 'assets/img/logo_white.svg'" [ngStyle]="('design' | env).logoStyle" alt="">
        @if (!('design' | env).noTagline) {
          <div class="tagline mt-3 font-weight-600 ms-2" [ngClass]="{'text-white': !('design' | env).logoWhiteBg, 'text-dark': ('design' | env).logoWhiteBg}">Let's get you connected</div>
        }
      </div>
    </div>
  </div>
  <div class="right-side">
    <div class="login-content">
      <div class="card align-items-center pt-5">
        <img class="logo mb-4" style="height: 48px;" src="assets/img/logo.svg" alt="">

        <p class="fs-16 font-weight-600 mb-4">{{ 'LOGIN.TITLE' | translate:('design' | env) }}</p>

        <div class="login-form-wrapper w-100" [ngClass]="{'d-none': verification.open}">
          <form #loginForm="ngForm" id="loginForm" (ngSubmit)="onLogin(loginForm)" class="w-100">

            <input type="text" name="account" #loginAccount="ngModel" [(ngModel)]="loginUser.account" class="form-control fs-14" placeholder="{{ 'LOGIN.ACCOUNT-PLACEHOLDER' | translate }}" minlength="2" required>
            <p class="validation-text mb-0 mt-1 w-100 ps-2" [hidden]="!(loginAccount.errors && loginAccount.touched ? loginAccount.errors['required'] : false)">{{ 'LOGIN.ACCOUNT-REQUIRED' | translate }}</p>
            <p class="validation-text mb-0 mt-1 w-100 ps-2" [hidden]="!(loginAccount.errors && loginAccount.touched ? loginAccount.errors['minlength'] : false)">{{ 'LOGIN.ACCOUNT-SHORT' | translate }}</p>

            @if (!msLoginMode) {
              <div>
                <input type="text" name="username" #loginUsername="ngModel" [(ngModel)]="loginUser.username" class="form-control fs-14 mt-3" placeholder="{{ 'LOGIN.USERNAME-PLACEHOLDER' | translate }}" minlength="2" required>
                <p class="validation-text mb-0 mt-1 w-100 ps-2" [hidden]="!(loginUsername.errors && loginUsername.touched ? loginUsername.errors['required'] : false)">{{ 'LOGIN.USERNAME-REQUIRED' | translate }}</p>
                <p class="validation-text mb-0 mt-1 w-100 ps-2" [hidden]="!(loginUsername.errors && loginUsername.touched ? loginUsername.errors['minlength'] : false)">{{ 'LOGIN.USERNAME-SHORT' | translate }}</p>
              </div>
            }

            @if (!msLoginMode) {
              <div>
                <input type="password" name="password" #loginPassword="ngModel" [(ngModel)]="loginUser.password" class="form-control fs-14 mt-3" placeholder="{{ 'LOGIN.PASSWORD-PLACEHOLDER' | translate }}" minlength="6" required>
                <p class="validation-text mb-0 mt-1 w-100 ps-2" [hidden]="!(loginPassword.errors && loginPassword.touched ? loginPassword.errors['required'] : false)">{{ 'LOGIN.PASSWORD-REQUIRED' | translate }}</p>
                <p class="validation-text mb-0 mt-1 w-100 ps-2" [hidden]="!(loginPassword.errors && loginPassword.touched ? loginPassword.errors['minlength'] : false)">{{ 'LOGIN.PASSWORD-SHORT' | translate }}</p>
              </div>
            }

            <div class="form-group d-flex align-items-center mt-3">
              <a class="more-options" style="cursor: pointer; font-size: 12px;" (click)="moreOptionsOpen = !moreOptionsOpen">
                <span class="fs-14">{{ 'LOGIN.MORE-OPTIONS' | translate }}</span>
                <i class="mi mi-expand-more" [ngClass]="{'mi-expand-less': moreOptionsOpen, 'mi-expand-more': !moreOptionsOpen}"></i>
              </a>
            </div>

            <div class="form-group align-items-center ms-3 mt-2" [ngClass]="{'d-flex': moreOptionsOpen, 'd-none': !moreOptionsOpen}">
              <input type="checkbox" id="remember" name="remember"  [(ngModel)]="accountNameDontRemeber" class="form-check-input mt-0 me-2">
              <label for="remember" class="form-check-label fs-14 font-weight-600 text-dark-grey">{{ 'LOGIN.REMEMBER-ACCOUNT-NAME' | translate }}</label>
            </div>

            <div class="form-group align-items-center ms-3 mt-2" [ngClass]="{'d-flex': moreOptionsOpen, 'd-none': !moreOptionsOpen}">
              <input type="checkbox" id="chinaserver" name="chinaserver" [(ngModel)]="useChinaServer" (ngModelChange)="chinaServerChange($event)" class="form-check-input mt-0 me-2">
              <label for="chinaserver" class="form-check-label fs-14 font-weight-600 text-dark-grey">{{ 'LOGIN.ALTERNATIVE-CONN-MODE' | translate }}</label>
            </div>

            <div class="w-100"></div>
          </form>
        </div>

        <div class="verification-wrapper w-100 my-4" [ngClass]="{'d-block': verification.open, 'd-none': !verification.open}">
          <div class="mb-3 fs-14">{{ 'LOGIN.VERIFICATION-SENDED' | translate }}</div>
          <form #verificationForm="ngForm" id="verificationForm" (ngSubmit)="onVerify(verification.code)" class="mt-4">
            <div class="form-group">
              <input class="form-control fs-14" placeholder="{{ 'LOGIN.VERIFICATION-CODE' | translate }}" type="text" name="verificationCode"
                #verificationCode="ngModel" [(ngModel)]="verification.code" required
                [ngClass]="{'is-invalid':verificationCode.errors && verificationCode.touched}"/>
              <p class="validation-text mb-0 mt-1 w-100 ps-2" [hidden]="!(verificationCode.errors && verificationCode.touched ? verificationCode.errors['required'] : false)">{{ 'LOGIN.VERIFICATION-CODE' | translate }} is required</p>
            </div>
          </form>
        </div>

        @if (verification.open) {
          <button form="verificationForm" class="v-btn btn btn-primary fs-15 font-weight-600 text-white open-button mt-3 mb-4" [disabled]="!verificationForm.valid">{{ 'LOGIN.VERIFY-BUTTON' | translate }}</button>
        }
        @if (!verification.open && !msLoginMode) {
          <button form="loginForm" class="v-btn btn btn-primary fs-15 font-weight-600 text-white open-button mt-3 mb-3" [disabled]="!loginForm.valid">{{ 'LOGIN.LOGIN-BUTTON' | translate }}</button>
        }
        @if (msLoginMode) {
          <button class="v-btn btn btn-secondary fs-15 font-weight-600 text-white open-button mt-3 mb-4" (click)="msLoginMode = false">{{ 'LOGIN.BACK' | translate }}</button>
        }

        @if (!verification.open && ('design' | env).showMsLogin) {
          <button class="v-btn btn btn-outline-primary fs-14 font-weight-600 d-flex align-items-center justify-content-center mb-3" style="width: 100%;" (click)="loginWithMicrosoft(loginForm)">
            <img [src]="('design' | env).msLoginSquareLogo ? 'assets/img/square_logo.png' : 'assets/ms-logo.svg'" style="width: 24px; height: 24px;" class="me-2">
            @if (currentLang.code !== 'de') {
              <span>{{ ('design' | env).msLoginText }}</span>
            }
            @if (currentLang.code === 'de') {
              <span>{{ ('design' | env).msLoginTextDE }}</span>
            }
          </button>
        }

        @if (!verification.open && ('design' | env).showSsoLogin && ('oidcConfig' | env)) {
          <button class="v-btn btn btn-outline-primary fs-14 font-weight-600 d-flex align-items-center justify-content-center mb-3" style="width: 100%;" (click)="loginWithOidc(loginForm)">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor" class="me-2" aria-hidden="true">
              <path d="M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>
            </svg>
            <span>{{ 'LOGIN.SSO-BUTTON' | translate }}</span>
          </button>
        }

        <div class="fs-12 font-weight-500 w-100 mb-4" style="max-width: 390px;">{{ 'LOGIN.BEFORE-TERMS' | translate }}
          @if (!('design' | env).hideTermsOfService) {
            @if (!('design' | env).unclickableTerms) {
              <a (click)="onTermsofService()" [style.color]="('design' | env).linkColor" class="cursor-pointer">{{ 'LOGIN.TERMS' | translate }}</a>
            }
            @if (('design' | env).unclickableTerms) {
              <a [style.color]="('design' | env).linkColor" class="cursor-pointer">{{ 'LOGIN.TERMS' | translate }}</a>
            }
            <span>{{ 'LOGIN.CONJUNCTION' | translate }}</span>
          }
          @if (!('design' | env).unclickableTerms) {
            <a (click)="onPrivacyPolicy()" [style.color]="('design' | env).linkColor" class="cursor-pointer">{{ 'LOGIN.PRIVACY' | translate }}</a>
          }
          @if (('design' | env).unclickableTerms) {
            <a [style.color]="('design' | env).linkColor" class="cursor-pointer">{{ 'LOGIN.PRIVACY' | translate }}</a>
          }
          <span>{{ 'LOGIN.AFTER-PRIVACY' | translate }}</span>
        </div>
      </div>
      <div class="addition-part mt-3 d-flex justify-content-center w-100">
        <div class="language-dropdown" dropdown [dropup]="true" #dropdown="bs-dropdown">
          <div id="language-toggle" class="language-link d-flex flex-row align-items-center cursor-pointer" dropdownToggle aria-controls="language-menu">
            <span class="name fs-14 font-weight-500 lang ms-2 color-blue-text">{{ currentLang.code | uppercase }}</span>
            <i id="dropdown-icon" class="mi mi-keyboard-arrow-down lang color-blue-text"></i>
          </div>
          <ul id="language-menu" *dropdownMenu class="dropdown-menu py-0" role="menu" aria-expanded="false" aria-labelledby="language-toggle">
            @for (lang of allLangs; track lang) {
              @if (currentLang !== lang) {
                <li class="language-item" role="menuitem">
                  <a class="dropdown-item language-link px-2 fs-14 font-weight-500" (click)="onLanguageSelected(lang)">{{ lang.code | uppercase }}</a>
                </li>
              }
            }
          </ul>
        </div>

      </div>
    </div>
  </div>
</div>